<div
  class="cre-sport-team-banner"
  *ngIf="teamLogo"
  [ngStyle]="{
    'background-image':
      'linear-gradient(147deg, ' + teamLogo.primaryColor + ', ' + teamLogo.secondaryColor
  }"
>
  <div
    class="cre-sport-team-banner-watermark"
    [ngStyle]="{ 'background-image': 'url(' + watermarkImageUrl + ')' }"
  ></div>
  <div class="cre-sport-team-banner-content">
    <ng-content></ng-content>
  </div>
</div>
